import Collection from '../Model/Collection';

import OrganizationProfile from '../Admin/Screens/OrganizationProfile';

export class OrganizationProfile_Collection extends Collection {
  constructor(props, onSetState, onApiError, organizationId, onAlert) {
    if (typeof organizationId !== "string") {
      console.log("Warning: organizationId required and not found");
    }
    if (typeof onAlert !== "function") {
      console.log("Warning: onAlert required and not found");
    }
    super(props, onSetState, onApiError, false, false);

    this.HideToolHeader = true;
    this.PassThroughComponent = (
      <OrganizationProfile
        {...props}
        organizationId={organizationId}
        // returnContentOnly (there is no other option)
        onApiError={onApiError}
        onAlert={onAlert}
      />
    );
  }
}